import {Invoicing} from "mapping/invoicing";
import {get} from "lodash";

export const Profile = {
    fromServer: (data, expanded = true) => {
        const info = data.info;
        const profile = {
            image: info.avatar,
            firstName: data.first_name,
            lastName: data.last_name,
            birthDate: info.birthday,
            gender: info.gender,
            office: info.osa_hq,
            userBio: info.bio,
            phone: data.phone,
            languages: info.languages,
            linkedin: info.linkedin_url,
            twitter: info.twitter_url,
            website: info.site_url,
            skills: info.skills,
            skills_raw: Object.values(data.skills || []),
            interests: info.interests || [],
            links: info.links,
            email: data.email,
            slug: data.slug,
            created_at: data.created_at,
            id: data.id,
            special_request_remaining: get(data, 'special_requests_remaining', 0),
            favorite: data.marked_as_favourite,
            sub_type: data.plan
        }
        if( expanded ) {
            profile.invoicing = Invoicing.fromServer(data.invoicing);
            profile.cards = data.payment_methods;
            profile.settings = data.settings;
        }
        return profile;
    },
    toServer: (profile) => {
        return {
            first_name: profile.firstName,
            last_name: profile.lastName,
            phone: profile.phone,
            info: {
                birthday: profile.birthDate,
                gender: profile.gender,
                osa_hq: profile.office,
                languages: profile.languages,
                skills: profile.skills,
                interests: profile.interests,
                linkedin_url: profile.linkedin,
                site_url: profile.website,
                twitter_url: profile.twitter,
                links: profile.links,
                bio: profile.userBio,
                avatar: profile.image
            }
        }
    }
}